import * as React from 'react';
import { useIntl } from 'react-intl';

import { IconSolidStar } from '@notino/react-styleguide';

import { IReviewSummary } from '@containers/ProductDetailContainer/model';
import { useTrackingContext } from '@context/tracking/TrackingContext';

import { messages } from '../../messages';
import { trackFiltration } from '../../ReviewItems/SortFilterBar/Filters/tracking';
import { sortFilterBarMessages } from '../../ReviewItems/SortFilterBar/messages';
import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../ReviewItems/SortFilterBar/Stores/filtersStore';

import {
  ProgressWrapper,
  RatingRowButton,
  RatingsValue,
  StarsBox,
  StarsValue,
  StarReviews,
  StyledProgressBar,
  ReviewsCount,
} from './styled';

interface IStarSummaryProps {
  reviewSummary: IReviewSummary;
}

export const StarsSummary: React.FC<IStarSummaryProps> = ({
  reviewSummary,
}) => {
  const { formatMessage } = useIntl();
  const { selectSingleRating } = useReviewFilterActions();
  const selectedRatings = useReviewFiltersStore(
    (state) => state.selections.rating
  );
  const { getTimeFromInit } = useTrackingContext();

  const onRatingClick = (star: string) => {
    selectSingleRating(Number(star));

    trackFiltration({
      interaction: 'filtration_quick_use',
      timing: getTimeFromInit(),
      name: star,
      action: 'filtration_quick_used',
      type: 'ratings',
    });
  };

  const votesWithDefaults = {
    5: 0,
    4: 0,
    3: 0,
    2: 0,
    1: 0,
    ...reviewSummary.votes,
  };

  return (
    <StarReviews
      data-cypress="reviews-starsSummary"
      role="group"
      aria-label={formatMessage(sortFilterBarMessages.rating)}
    >
      {Object.keys(votesWithDefaults)
        .sort((a, b) => Number(b) - Number(a))
        .map((stars) => (
          <RatingRowButton
            key={stars}
            type="button"
            onClick={() => onRatingClick(stars)}
            aria-pressed={
              selectedRatings.length === 1 &&
              Number(selectedRatings[0]) === Number(stars)
            }
            aria-label={formatMessage(messages.starsSummaryRowAriaLabel, {
              stars,
              count: votesWithDefaults[stars],
            })}
          >
            <RatingsValue>
              <StarsValue>{stars}</StarsValue>
              <StarsBox>
                <IconSolidStar
                  width="14px"
                  height="14px"
                  color="icon.primary"
                />
              </StarsBox>
            </RatingsValue>
            <ProgressWrapper>
              <StyledProgressBar
                name={stars}
                max={reviewSummary.totalVotes}
                value={votesWithDefaults[stars]}
                height={4}
              />
              <ReviewsCount>{votesWithDefaults[stars]}</ReviewsCount>
            </ProgressWrapper>
          </RatingRowButton>
        ))}
    </StarReviews>
  );
};
